<template>
  <div
    class="question-modal"
  >
    <question-list
      @onSelectQuestion="$emit('onSelectQuestion', $event)"
      :use-sub-selection="useSubSelection"
      :selected-question="selectedQuestion"
      :selected-levels="selectedLevels"
    />
    <div
      class="mouse-capture"
      @click="$emit('onClosePopup')"
    />
  </div>
</template>

<script>
import QuestionList from './QuestionList.vue'
export default {
  name: 'QuestionModal',
  components: { QuestionList },
  emits: ['onSelectQuestion', 'onClosePopup', 'onListOpen'],
  props: {
    useSubSelection: {
      type: Boolean,
      default: false
    },
    selectedQuestion: {
      type: Object,
      default: null
    },
    selectedLevels: {
      type: Object,
      default: null
    }
  },
  mounted () {
    this.$emit('onListOpen')
  }
}
</script>

<style lang="scss" scoped>
  .question-modal {
    box-shadow: 3px 5px 10px rgb(118 136 147 / 50%);
    position: absolute;
    z-index: 100;
    width: 60rem;
    max-width: 90%;

    .question-list {
      z-index: 10;
    }

    .mouse-capture {
      position: fixed;
      left: 0px;
      right: 0px;
      top: 0px;
      bottom: 0px;
      background-color: rgba(0, 0, 0, 0.0);
      z-index: -10;
    }
  }
</style>
